import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=7324cce5&scoped=true"
import script from "./Configurator.vue?vue&type=script&lang=ts"
export * from "./Configurator.vue?vue&type=script&lang=ts"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=7324cce5&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7324cce5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7324cce5')) {
      api.createRecord('7324cce5', component.options)
    } else {
      api.reload('7324cce5', component.options)
    }
    module.hot.accept("./Configurator.vue?vue&type=template&id=7324cce5&scoped=true", function () {
      api.rerender('7324cce5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Configurator.vue"
export default component.exports